<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="goback_search">
        <el-input
          v-model="searchValue"
          placeholder="请输入..."
          @input="changeSearchValue"
        ></el-input>
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="content">
      <div class="top">
        <div class="top_left">签到列表：</div>
        <div class="load" v-if="mobofpc" @click="exportExcel">
          <img src="@/assets/newMedal/publicWelfare/download.png" alt="" />
          导出
        </div>
      </div>
      <div class="table">
        <div class="table_header">
          <div class="header_item">序号</div>
          <div class="header_item">工号</div>
          <div class="header_item">姓名</div>
          <div class="header_item">所属部门</div>
          <div class="header_item">签到时间</div>
          <div class="header_item">签退时间</div>
        </div>
        <div class="table_body" v-if="historyList.length > 0">
          <!-- <van-list
            v-if="historyList.length > 0"
            v-model="loadingOne"
            :finished="finishedOne"
            finished-text="没有更多了"
            @load="onLoadOne"
            loading-text="加载中，下拉查看更多"
            offset="10"
            :immediate-check="false"
          > -->
          <div class="body_item" v-for="(v, i) in historyList" :key="i">
            <div class="item_num">{{ i + 1 }}</div>
            <div class="item_num">{{ v.empNo }}</div>
            <div class="item_num">{{ v.empName }}</div>
            <div class="item_num">{{ v.departmentName }}</div>
            <div class="item_num">{{ v.signInStartTime }}</div>
            <div class="item_num">{{ v.signInEndTime }}</div>
          </div>
          <!-- </van-list> -->
        </div>
        <div class="no_data" v-else>暂无人签到</div>
      </div>
      <div class="activity">
        <div class="title">{{userinfo.title}}</div>
        <div class="filed_item">
          <div class="filed_label">活动日期：</div>
          <div class="filed_value">
            {{ userinfo.startTime }} <span style="margin: 0 5px">—</span>
            {{ userinfo?.endTime }}
          </div>
        </div>
        <div class="filed_item">
          <div class="filed_label">报名人数：</div>
          <div
            class="filed_value filed_value1"
            @click="
              toRouter(
                '/mobile/medal/publicWelfare/signStatisticsDetail',
                (type = 2)
              )
            "
          >
            {{ userinfo.applyNum }}
          </div>
        </div>
        <div class="filed_item">
          <div class="filed_label">未签到人数：</div>
          <div
            class="filed_value filed_value1"
            @click="
              toRouter(
                '/mobile/medal/publicWelfare/signStatisticsDetail',
                (type = 4)
              )
            "
          >
            {{
              userinfo.applyNum &&
              Number(userinfo.applyNum) - userinfo.signInStartNum &&
              Number(userinfo.signInStartNum)
            }}
          </div>
        </div>
        <div class="filed_item">
          <div class="filed_label">累计签到人数：</div>
          <div
            class="filed_value filed_value1"
            @click="
              toRouter(
                '/mobile/medal/publicWelfare/signStatisticsDetail',
                (type = 1)
              )
            "
          >
            {{ userinfo.signInStartNum }}
          </div>
        </div>
        <div class="filed_item">
          <div class="filed_label">累计签退人数：</div>
          <div
            class="filed_value filed_value1"
            @click="
              toRouter(
                '/mobile/medal/publicWelfare/signStatisticsDetail',
                (type = 3)
              )
            "
          >
            {{ userinfo.signInEndNum }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import api from "@/apis/medal";
import moment from "moment";
import apis from "@/apis/publicWelfare";
import { downloadExcel, redirectRoute } from "@/utils/tools.js";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      searchValue: "",
      historyList: [],
      userinfo: {},
      loadingOne: false,
      finishedOne: false,
      total: 0,
      page: 1,
      pageSize: 10,
      mobofpc: false,
    };
  },
  created() {},
  mounted() {
    this.onLoadOne();
    this.getDetail();
    this.redirect();
  },
  methods: {
    //判断是否是手机端
    redirect() {
      this.mobofpc = redirectRoute();
    },
    //返回上一页
    goback() {
      this.$router.go(-1);
    },
    onLoadOne() {
      this.queryHistoryRecord();
    },
    //获取活动详情
    getDetail() {
      apis
        .detail({
          id: this.$route.query.id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.userinfo = res.data;
            this.userinfo.startTime = moment(this.userinfo.startTime).format(
              "YYYY/MM/DD HH:mm"
            );
            this.userinfo.endTime = moment(this.userinfo.endTime).format(
              "YYYY/MM/DD HH:mm"
            );
          }
        });
    },
    //获取历史记录
    queryHistoryRecord() {
      apis
        .signInStatistics({
          // page: this.page,
          // pageSize: this.pageSize,
          activityId: this.$route.query.id,
          empName: this.searchValue,
          type: 1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.historyList = res.data;
            this.historyList.forEach((item) => {
              item.signInStartTime = item.signInStartTime
                ? moment(item.signInStartTime).format("YYYY-MM-DD HH:mm")
                : "暂无";
              item.signInEndTime = item.signInEndTime
                ? moment(item.signInEndTime).format("YYYY-MM-DD HH:mm")
                : "暂无";
            });
            // this.total = res.data.total;
            // this.finishedOne = false;
            // if (this.page === 1) {
            //   this.historyList = res.data.list;
            // } else {
            //   this.historyList = this.historyList.concat(res.data.list);
            // }
            // if (this.historyList.length < this.total) {
            //   this.page = this.page + 1;
            // } else {
            //   this.finishedOne = true;
            // }

            // this.loadingOne = false;
            // this.historyList.map((item) => {
            //   item.create_time = moment(item.create_time).format("YYYY-MM-DD");
            // });
          }
        });
    },
    //改变搜索框
    changeSearchValue() {
      this.queryHistoryRecord();
    },
    //跳转到详情页
    toRouter(path, type) {
      this.$router.push({
        path: path,
        query: { type: type, id: this.$route.query.id },
      });
    },
    //导出签到统计
    exportExcel() {
      apis
        .visitorLogExport({
          activityId: this.$route.query.id,
          type: 1,
        })
        .then((res) => {
          downloadExcel(res, "签到统计", "xlsx");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .content {
    margin-top: 30px;
    height: calc(100vh - 230px);
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      padding-left: 20px;
      .top_left {
        font-size: 30px;
      }
      .load {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f2f2f2;
        border-radius: 10px;
        font-size: 10px * $zoom;
        padding: 10px 20px;
        color: #7d8592;
        img {
          width: 44px;
          height: 44px;
          margin-right: 10px;
        }
      }
    }
    .table {
      padding: 30px 0 0;
      background: linear-gradient(to right, #e6f6f1, #fff);
      border-radius: 40px;
      font-size: 11px * $zoom;
      // padding: 0 10px;
      overflow-x: auto; /* 开启横向滚动 */
      @media screen and (min-width: 600px) {
        &::-webkit-scrollbar {
          // width: 3px;
          height: 10px;
          background-color: #1fbe8a;
          border-radius: 4px;
        }

        /*定义滚动条轨道 内阴影+圆角*/
        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
          border-radius: 2px;
          background-color: #ccc;
        }

        /*定义滑块 内阴影+圆角*/
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.1);
          background-color: #1fbe8a;
        }
      }

      @media screen and (max-width: 600px) {
        &::-webkit-scrollbar {
          display: none;
        }
      }

      .table_header {
        display: flex;
        align-items: center;
        padding: 0 10px 30px;
        // overflow-x: auto; /* 开启横向滚动 */
        width: 195%;
        // white-space: nowrap; /* 禁止子元素换行 */
        .header_item {
          // flex-shrink: 0; /* 防止宽度被压缩 */
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .header_item:nth-child(1) {
          width: 15%;
        }
        .header_item:nth-child(2) {
          width: 25%;
        }
        .header_item:nth-child(3) {
          width: 25%;
        }
        .header_item:nth-child(4) {
          width: 40%;
        }
        .header_item:nth-child(5) {
          width: 45%;
        }
        .header_item:nth-child(6) {
          width: 45%;
        }
      }
      .table_body {
        // display: flex;
        // align-items: center;
        // margin-top: 30px;
        padding-top: 30px;
        background: #fff;
        border-radius: 40px;
        overflow: auto;
        width: 195%;
        max-height: 600px;
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .body_item {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-bottom: 15px;
        }
        .item_num {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          display: inline-block;
          white-space: nowrap; /* 防止换行 */
          overflow: hidden; /* 超出内容隐藏 */
          text-overflow: ellipsis; /* 超出内容显示省略号(...) */
          text-align: center;
        }
        .item_num:nth-child(1) {
          width: 15%;
        }
        .item_num:nth-child(2) {
          width: 25%;
        }
        .item_num:nth-child(3) {
          width: 25%;
        }
        .item_num:nth-child(4) {
          width: 40%;
        }
        .item_num:nth-child(5) {
          width: 45%;
        }
        .item_num:nth-child(6) {
          width: 45%;
        }
        ::v-deep {
          .van-list__finished-text {
            line-height: 0;
            margin-bottom: 50px;
          }
        }
      }
    }
    .activity {
      margin-top: 30px;
      padding: 30px 50px 50px;
      background: #fff;
      border-radius: 40px;
      font-size: 11px * $zoom;
      .title {
        text-align: center;
        font-size: 13px * $zoom;
      }
      .filed_item {
        margin-top: 30px;
        display: flex;
        align-items: flex-start;
        .filed_label {
          margin-top: -5px;
          color: #666666;
          // 文字不换行
          white-space: nowrap;
        }
        .filed_value1 {
          color: #2e93fa;
          text-decoration: underline;
        }
      }
    }
  }
}
.no_data {
  padding: 30px;
  text-align: center;
  color: #666;
  font-size: 30px;
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 30px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
</style>
